import { http } from 'wagmi';
import { createConfig } from '@privy-io/wagmi';
import { polygon } from 'viem/chains';

export const currentChain = polygon

const allChains = [
  currentChain
];

export const wagmiConfig = createConfig({
  chains: allChains,
  transports: Object.fromEntries(allChains.map(chain => [chain.id, http()])),
});
